/**
 * One entry in the account-scoped, reusable HTML template library
 * (backed by TransactionalEmailHtmlTemplate on the server). Shared by
 * Transactional Email and MT-Transactional Email - the endpoint has no
 * type/activity scoping.
 */
export interface TransactionalEmailHtmlTemplateModel {
  id: string;
  name: string;
  content: string;
  fileSize?: number;
  createdBy?: string;
  createdDate?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
}
